// B.A.Savage — Scroll fade-up animations
// Targets any element with class "bas-fade-up"
// Add class="bas-fade-up" to any Dawn section wrapper you want to animate
//
// Safety notes:
//  - .bas-fade-up starts at opacity 0 in CSS, so anything that fails to be
//    observed stays invisible. Every path below must end in .visible.
//  - The theme editor swaps section DOM on every setting change, so we re-scan
//    on shopify:section:load / :select as well as on initial load.

(function () {
  var THRESHOLD = 0.12;
  var observer = null;

  function reveal(el) {
    el.classList.add('visible');
  }

  function revealAll() {
    document.querySelectorAll('.bas-fade-up').forEach(reveal);
  }

  // No IntersectionObserver, or the visitor asked for reduced motion:
  // show everything immediately rather than risk hiding content.
  function shouldSkipAnimation() {
    if (!('IntersectionObserver' in window)) return true;
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: THRESHOLD });
    return observer;
  }

  // Observe anything not already handled. Safe to call repeatedly.
  function scan(root) {
    if (shouldSkipAnimation()) {
      revealAll();
      return;
    }

    var scope = root && root.querySelectorAll ? root : document;
    var targets = scope.querySelectorAll('.bas-fade-up:not(.visible):not([data-bas-observed])');
    if (!targets.length) return;

    var obs = getObserver();
    targets.forEach(function (el) {
      el.setAttribute('data-bas-observed', '');

      // Already on screen when it appeared (common in the theme editor, and on
      // short pages where nothing ever scrolls): reveal without waiting.
      var rect = el.getBoundingClientRect();
      var inView = rect.top < window.innerHeight && rect.bottom > 0;
      if (inView) {
        reveal(el);
        return;
      }

      obs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Theme editor: sections are re-rendered and swapped in, losing observers.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:select', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:reorder', function () { scan(); });

  // Last-resort net: if anything is still hidden well after load, show it.
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('.bas-fade-up:not(.visible)').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) reveal(el);
      });
    }, 400);
  });
})();